// src/components/HeaderLocked.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const HeaderLocked = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  function calculateTimeLeft() {
    const launchDate = new Date('2025-04-30T00:00:00');
    const now = new Date();
    const difference = launchDate - now;

    return {
      dagar: Math.floor(difference / (1000 * 60 * 60 * 24)),
      timmar: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minuter: Math.floor((difference / 1000 / 60) % 60),
      sekunder: Math.floor((difference / 1000) % 60)
    };
  }

  return (
    <header className="header bg-[#282c34] text-white w-full fixed top-0 z-50 shadow-md">
      <div className="container flex max-w-none items-center justify-between px-4 py-3">
        {/* Logotyp */}
        <div className="flex items-center">
          <Link to="/">
            <img src="/images/logo.webp" alt="Fabelia" className="logo-image" />
          </Link>
          <h1 className="logo text-warmWhite font-bold text-xl ml-16 neon-text">
            <Link to="/">Fabelia</Link>
          </h1>
        </div>

        {/* Countdown + Affiliate-länk */}
        <div className="flex items-center space-x-8">
          <Link 
            to="/affiliate" 
            className="text-warmWhite hover:text-gold font-semibold transition-colors duration-300"
          >
            Affiliate
          </Link>
          
          <div className="flex items-center space-x-4">
            <span className="text-warmWhite italic text-xl">
              Äventyret börjar om:
            </span>
          <div className="flex space-x-2">
            {timeLeft.dagar > 0 && (
              <div className="text-center">
                <div className="text-2xl font-bold">{timeLeft.dagar}</div>
                <div className="text-xs">dagar</div>
              </div>
            )}
            <div className="text-center">
              <div className="text-2xl font-bold">{timeLeft.timmar}</div>
              <div className="text-xs">timmar</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold">{timeLeft.minuter}</div>
              <div className="text-xs">minuter</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold">{timeLeft.sekunder}</div>
              <div className="text-xs">sekunder</div>
            </div>
          </div>
        </div>

        {/* Hamburgermeny-knapp (inaktiverad) */}
        <button
          className="lg:hidden text-white focus:outline-none opacity-50 cursor-not-allowed"
          disabled
        >
          <FontAwesomeIcon icon={faBars} className="w-6 h-6" />
        </button>
      </div>
      </div>
    </header>
  );
};

export default HeaderLocked;